import { atom } from "recoil";

export const blackListWithdrawalsStore = atom({
	key: "blackListWithdrawalsStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOrder: "",
		currentSearchType: "",
		currentDirection: "desc",
		currentSearch: "",
		selectedItems: [],
		sorting: {
			sortingColumn: {
				order: "",
				column: "",
			},
			isDescending: false,
		},
		pagination: {
			current: 0,
			total: 0,
			count: 0,
		},
		currentType: "",
		currentOption: {
			type: false,
			order: false,
			direction: false,
		},
	},
});
